import { ENTER_KEY, SPACE_KEY } from '../constants/generalConstants.js';

/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */
var isEnterKeyPressed = function isEnterKeyPressed(event) {
  return event.keyCode === ENTER_KEY.CODE || event.key === ENTER_KEY.VALUE || event.charCode === ENTER_KEY.CHAR_CODE;
};
var isSpaceKeyPressed = function isSpaceKeyPressed(event) {
  return event.keyCode === SPACE_KEY.CODE || event.key === SPACE_KEY.VALUE || event.charCode === SPACE_KEY.CHAR_CODE;
};

export { isEnterKeyPressed, isSpaceKeyPressed };
